import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DisqusThread from 'react-disqus-comments-sso';
import { setCurrentSection } from '../../actions/globalConfig';
import './styles.scss';
import PageContent from '../../components/StaticPage/PageContent';
import NotFoundView from '../NotFound';
import { disqusCheckAndRefreshSSO } from '../../actions/auth';

const propTypes = {
  statusText: PropTypes.string,
  sectionName: PropTypes.string,
  userName: PropTypes.string,
  profileImage: PropTypes.string,
  remoteAuthS3: PropTypes.string,
};

const defaultProps = {
  sectionName: '',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png',
  shortName: 'exploreorg',
  remoteAuthS3: '',
};

class StaticDisqusView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      queryResults: {},
      query: _.get(this.props, 'params.content', null),
    };
    this.handleNewComment = this.handleNewComment.bind(this);
  }

  componentDidMount() {
    const { pageTitle } = this.props;
    this.props.dispatch(disqusCheckAndRefreshSSO());
    this.ssoInterval = setInterval(() => {
      this.props.dispatch(disqusCheckAndRefreshSSO());
    }, 1000 * 60);
    if (!contentTitle) return;
    let contentTitle = this.replaceAll(pageTitle, '-', ' ');
    this.props.dispatch(setCurrentSection(contentTitle));
  }

  componentWillReceiveProps(nextProps) {
    this.props.dispatch(disqusCheckAndRefreshSSO());
  }

  componentDidUpdate() {
    const { pageTitle } = this.props;
    if (!contentTitle) return;
    let contentTitle = this.replaceAll(pageTitle, '-', ' ');
    this.props.dispatch(setCurrentSection(contentTitle));
  }

  escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

  ssoConfig() {
    const baseUrl = window.location.origin;
    return {
      name: 'explore.org',
      button: 'https://explore.org/images/disqus-sso-login-button.png',
      icon: 'https://explore.org/images/favicon.png',
      url: `${baseUrl}/accounts/login/`,
      logout: `${baseUrl}/accounts/logout/`,
      width: '800',
      height: '400',
    };
  }

  handleNewComment(comment) {
    console.log(comment.text);
  }

  render() {
    const {
      pageTitle,
      isAuthenticated,
      shortName,
      remoteAuthS3,
      pageCommentsEnabled,
      disqusThreadVersion,
      pageContent,
      staticPageLoading,
      pageData,
    } = this.props;

    if (!pageContent && !staticPageLoading) {
      return (<NotFoundView />);
    }
    const { show_title: showTitle, published, css } = pageData;
    const slug = window.location.pathname;
    const identifier = disqusThreadVersion > 0 ? `${slug}-${disqusThreadVersion}` : slug;
    return (
      <div className="container-fluid content static-page bg-fff-65">
        {css && (
          <style>
            {css}
          </style>
        )}
        {!published && (
          <div className="row">
            <div className="col">
              <div className="alert alert-info">
                This page is in <strong>preview mode</strong>. To make it live, toggle the <strong>publish</strong> switch in the CMS
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12 pr-35 pl-35">
            {showTitle && (<h1>{pageTitle}</h1>)}
            <div className="static-page-top-block">&nbsp;</div>
            {pageContent && <PageContent content={pageContent} />}
          </div>
        </div>
        {pageCommentsEnabled && (
          <div className="row">
            <div className="col-sm-12 pr-35 pl-35">
              {(isAuthenticated) ?
                (
                  <DisqusThread
                    shortname={shortName}
                    api_key={DISQUS_PUBLIC_KEY}
                    remote_auth_s3={remoteAuthS3}
                    identifier={identifier}
                    onNewComment={this.handleNewComment}
                    url={`${window.location.protocol}//${window.location.host}${window.location.pathname}?disqus=${identifier}`}
                    sso={this.ssoConfig()}
                  />
                ) : (
                  <DisqusThread
                    shortname={shortName}
                    onNewComment={this.handleNewComment}
                    identifier={identifier}
                    url={`${window.location.protocol}//${window.location.host}${window.location.pathname}?disqus=${identifier}`}
                    sso={this.ssoConfig()}
                  />
                )
              }
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath,
    pageContent: state.globalConfig.pageContent,
    pageTitle: state.globalConfig.pageTitle,
    pageCommentsEnabled: state.globalConfig.pageCommentsEnabled,
    disqusThreadVersion: state.globalConfig.disqusThreadVersion,
    remoteAuthS3: state.auth.disqus_sso,
    isAuthenticated: state.auth.isAuthenticated,
    staticPageLoading: state.globalConfig.staticPageLoading,
    pageData: state.globalConfig.pageData,
  };
};

StaticDisqusView.propTypes = propTypes;
StaticDisqusView.defaultProps = defaultProps;

export default connect(mapStateToProps)(StaticDisqusView);
